import { render, staticRenderFns } from "./ModalFaq.vue?vue&type=template&id=6f2c699b&scoped=true"
import script from "./ModalFaq.vue?vue&type=script&lang=js"
export * from "./ModalFaq.vue?vue&type=script&lang=js"
import style0 from "./ModalFaq.vue?vue&type=style&index=0&id=6f2c699b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2c699b",
  null
  
)

export default component.exports